export default {
  supplierpartners: {
    subtitle: "SUPPLIER PARTNERS",

    title1: "Trusted by",
    title2: "Leading Suppliers",

    desc:
      "From local producers to large distributors, suppliers across categories trust MAHAL to grow their business and reach restaurants at scale.",

    metric1: "Active Suppliers",
    metric2: "Restaurants Served",
    metric3: "Bulk Orders",

    cta: "Join as a Supplier",
  },
};